
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function WMS() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('https://public.readdy.ai/ai/img_res/01d7fe383d1cc7efd0b7cde75349d895.jpg')`
        }}
      >
        <div className="text-center text-white">
          <h1 className="text-5xl font-bold mb-4">WAREHOUSE MANAGEMENT SYSTEM</h1>
          <p className="text-xl">체계적인 실시간 물류정보 관리로 성공적 Business 창출</p>
        </div>
      </section>

      {/* WMS Benefits Section - Moved to top */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              WMS 도입 효과
            </h2>
            <p className="text-xl text-gray-600">
              올딩스 로지스 WMS로 얻을 수 있는 핵심 혜택
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Error Zero - Highlighted */}
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg shadow-xl p-8 border-2 border-red-200 transform hover:scale-105 transition-all duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-20 h-20 bg-red-500 rounded-lg flex items-center justify-center flex-shrink-0 shadow-lg">
                  <i className="ri-shield-check-line text-4xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-red-700 mb-2">Error Zero !!!</h3>
                  <p className="text-lg font-semibold text-red-600 mb-3">완벽한 정확성</p>
                  <p className="text-gray-700 text-lg">체계적인 관리 시스템으로 오류를 최소화하여 완벽한 서비스를 제공합니다.</p>
                </div>
              </div>
            </div>

            {/* 당일 반품처리 - Highlighted */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg shadow-xl p-8 border-2 border-blue-200 transform hover:scale-105 transition-all duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-20 h-20 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0 shadow-lg">
                  <i className="ri-refresh-line text-4xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-blue-700 mb-2">당일 반품처리 !!!</h3>
                  <p className="text-lg font-semibold text-blue-600 mb-3">신속한 처리</p>
                  <p className="text-gray-700 text-lg">효율적인 시스템으로 당일 반품 처리가 가능하여 고객 만족도를 극대화합니다.</p>
                </div>
              </div>
            </div>

            {/* 재고 부담 최소화 */}
            <div className="bg-white rounded-lg shadow-lg p-8 border border-gray-200">
              <div className="flex items-start space-x-4">
                <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-line text-3xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">재고 부담 최소화</h3>
                  <p className="text-lg font-semibold text-green-600 mb-3">물류비 최소화</p>
                  <p className="text-gray-600">정확한 재고 관리로 불필요한 재고 보유를 최소화하고 물류비용을 절감합니다.</p>
                </div>
              </div>
            </div>

            {/* 3PL 데이터 분석 */}
            <div className="bg-white rounded-lg shadow-lg p-8 border border-gray-200">
              <div className="flex items-start space-x-4">
                <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-bar-chart-box-line text-3xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">3PL 데이터 분석</h3>
                  <p className="text-lg font-semibold text-purple-600 mb-3">인사이트 제공</p>
                  <p className="text-gray-600">상세한 데이터 분석을 통해 비즈니스 인사이트와 개선 방안을 제공합니다.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Introduction */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              올딩스 로지스의 WMS
            </h2>
            <p className="text-2xl text-blue-600 font-semibold mb-8">
              고객님의 물류정보를 체계적으로 실시간 관리 및 제공하여<br />
              성공적 Business를 창출합니다
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20warehouse%20management%20system%20control%20center%20with%20multiple%20monitors%20displaying%20real-time%20inventory%20data%2C%20logistics%20tracking%20interfaces%2C%20and%20automated%20warehouse%20operations%20dashboard%20showing%20successful%20business%20performance%20analytics&width=600&height=400&seq=wms-control-center&orientation=landscape"
                alt="WMS 시스템"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900">
                실시간 물류 관리 시스템
              </h3>
              <div className="space-y-4 text-lg text-gray-700">
                <p>
                  <strong className="text-blue-600">실시간 데이터 관리</strong><br />
                  모든 물류 정보를 실시간으로 추적하고 관리합니다
                </p>
                <p>
                  <strong className="text-blue-600">체계적인 정보 제공</strong><br />
                  고객이 필요한 모든 정보를 체계적으로 제공합니다
                </p>
                <p>
                  <strong className="text-blue-600">성공적 비즈니스 창출</strong><br />
                  효율적인 물류 관리로 비즈니스 성공을 지원합니다
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Success Performance Diagram - Removed pulse animation */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Successful Performance
            </h2>
            <p className="text-xl text-gray-600">
              체계적인 프로세스로 성공적인 성과를 창출합니다
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 lg:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
              {/* Left Side - Input Factors */}
              <div className="space-y-6">
                <div className="bg-blue-50 rounded-full px-6 py-4 text-center">
                  <h3 className="text-lg font-semibold text-gray-900">로케이션 관리 효율화</h3>
                </div>
                <div className="bg-blue-50 rounded-full px-6 py-4 text-center">
                  <h3 className="text-lg font-semibold text-gray-900">표준업무 process</h3>
                </div>
                <div className="bg-blue-50 rounded-full px-6 py-4 text-center">
                  <h3 className="text-lg font-semibold text-gray-900">작업공정 분류 data</h3>
                </div>
                <div className="bg-blue-50 rounded-full px-6 py-4 text-center">
                  <h3 className="text-lg font-semibold text-gray-900">실업무 및 공정단축</h3>
                </div>
              </div>

              {/* Center - Success Circle - Removed pulse animation */}
              <div className="flex justify-center">
                <div className="relative">
                  <div className="w-64 h-64 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center shadow-2xl">
                    <div className="text-center text-white">
                      <h2 className="text-2xl font-bold mb-2">Successful</h2>
                      <h2 className="text-2xl font-bold">Performance</h2>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side - Output Results */}
              <div className="space-y-6">
                <div className="bg-green-50 rounded-full px-6 py-4 text-center">
                  <h3 className="text-lg font-semibold text-gray-900">재고 부담 최소화(물류비 최소화)</h3>
                </div>
                <div className="bg-green-50 rounded-full px-6 py-4 text-center">
                  <h3 className="text-lg font-semibold text-gray-900">당일 반품처리 !!!</h3>
                </div>
                <div className="bg-green-50 rounded-full px-6 py-4 text-center">
                  <h3 className="text-lg font-semibold text-gray-900">Error Zero !!!</h3>
                </div>
                <div className="bg-green-50 rounded-full px-6 py-4 text-center">
                  <h3 className="text-lg font-semibold text-gray-900">3pl data 분석</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WMS Features */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              WMS 핵심 기능
            </h2>
            <p className="text-xl text-gray-600">
              체계적이고 효율적인 창고 관리 시스템
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: '로케이션 관리',
                description: '창고 내 모든 위치를 체계적으로 관리하여 효율성 극대화',
                icon: 'ri-map-pin-line',
                color: 'blue'
              },
              {
                title: '표준업무 프로세스',
                description: '표준화된 업무 프로세스로 일관된 서비스 품질 보장',
                icon: 'ri-flow-chart',
                color: 'green'
              },
              {
                title: '작업공정 분류',
                description: '모든 작업 공정을 데이터화하여 최적화된 관리',
                icon: 'ri-database-2-line',
                color: 'purple'
              },
              {
                title: '실업무 공정단축',
                description: '실제 업무 프로세스를 단축하여 효율성 향상',
                icon: 'ri-speed-up-line',
                color: 'orange'
              }
            ].map((feature, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6 border border-gray-100 hover:shadow-xl transition-shadow">
                <div className={`w-16 h-16 bg-${feature.color}-100 rounded-lg flex items-center justify-center mb-6`}>
                  <i className={`${feature.icon} text-3xl text-${feature.color}-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
